// extracted by mini-css-extract-plugin
export default {"wrap":"ChangeLanguage_wrap__sZ0Sx","flag":"ChangeLanguage_flag__9INcw"};